<template>
  <header class="pt-4 header">
    <div class="container mx-auto max-w-4-5xl">
      <div class="ie-hero-heading flex flex-col items-center mt-2 mb-2 sm:flex-row jusitfy-between">
        <div class="w-6/6 md:ml-8 lg:ml-8 lg:mb-4 lg:w-auto md:w-5/6 lg:w-5/12">
        <Logo alt="Post Office Credit Card QuickCheck" class="inline-block w-16 md:w-12 lg:w-16 mr-5 h-14"></Logo>
          <span class="text-2xl font-semibold align-text-middle logo-text">Credit Card QuickCheck</span>
        </div>
        <div class="icons-block inline md:block lg:inline-flex mt-2 mb-3 w-4/6 lg:flex-row">
          <div class="ml-0 md:ml-5 icon-block ml-8 mt-4 md:ml-0 md:mt-0">
            <ShieldIcon alt="Shield Icon" class="inline-block float-left w-6 h-6 lg:w-10 lg:h-10 mr-2" />
            <div class="text-lg md:text-base lg:text-lg leading-snug">
              <p>Won't affect your credit score</p>
            </div>
          </div>
          <div class="hidden ml-0 md:ml-5 md:block icon-block">
            <ClockIcon alt="Clock Icon" class="inline-block float-left w-10 h-10 md:w-6 md:h-6 lg:w-10 lg:h-10 mr-2" />
            <div class="text-lg md:text-base lg:text-lg leading-snug">
              <p>60 second response time</p>
            </div>
          </div>
          <div class="hidden ml-0 md:ml-5 md:block icon-block">
            <TickIcon alt="Tick Icon" class="inline-block float-left w-10 h-10 md:w-6 md:h-6 lg:w-10 lg:h-10 mr-2" />
            <div class="text-lg md:text-base lg:text-lg leading-snug">
              <p>100% certainty before you apply</p>
            </div>
          </div>
        </div>
      </div>
      <main class="flex flex-col-reverse items-center pb-12 sm:flex-row jusitfy-between">
        <div class="flex md:ml-8 flex-col items-center px-6 text-center md:w-4/6 sm:items-start sm:text-left sm:px-0">
          <h1 class="ie-intro-container mb-4 mr-4 text-4xl font-semibold leading-none sm:text-5xl sm:mb-4 w-12/12">
            Find out now if you're eligible for a Post Office Credit Card
          </h1>
          <h2 class="ie-intro-container mb-2 text-base leading-tight sm:text-lg">
            In three steps, you can check your eligibility before applying for a credit card and without impacting your credit score.
          </h2>
          <NumberedList :items="header.numberedListItems"></NumberedList>
          <p class="text-xs font-semibold sm:text-base">
            Capital One is the exclusive lender and issuer of all new Post Office Credit Cards, for which Post Office acts as credit broker.
          </p>
        </div>
        <div class="w-3/6 md:w-1/3 lg:w-1/3 xl:w-1/3">
          <img class="Credit Cards" src="@/v2/assets/images/cards.png" alt="Post Office Credit Card">
        </div>
      </main>
    </div>
  </header>
</template>

<script>

// svgs
import Logo from '@/v2/assets/images/logos/post-office.svg'
import ShieldIcon from '@/v2/assets/images/icons/shield.svg'
import ClockIcon from '@/v2/assets/images/icons/clock.svg'
import TickIcon from '@/v2/assets/images/icons/tick.svg'

import NumberedList from '@/v2/components/elements/NumberedList'

export default {
  name: 'Header',
  data(){
    return {
      header: {
        numberedListItems: [
          'About you',
          'Where you live',
          'Work and Finances'
        ]
      }
    }
  },
  components: {
    Logo,
    ShieldIcon,
    ClockIcon,
    TickIcon,
    NumberedList
  }
}
</script>

<style scoped>

@screen md {
    .icon-block {
        display: flow-root;
        @apply mb-2;
    }
}

@screen lg {
    .icon-block {
        display: block;
    }
}

</style>